// TODO: What field represents 'oz'?

export default (projectId: string) => ({
  dataName: 'Position',
  dataSetName: 'Positionen',
  head: [
    {
      label: 'oz',
      key: 'id',
      col: 2,
      leftAlign: true,
    },
    {
      label: 'Systembezeichnung',
      key: 'systemDescription',
      leftAlign: true,
      col: 4,
      linkTo: `/projects/${projectId}/calculations`,
    },
    {
      label: 'Menge',
      key: 'amount',
      col: 2,
    },
    {
      label: 'Einheitspreis',
      key: 'unitPrice',
      col: 2,
      unit: 'EUR',
    },
    {
      label: 'Gesamtbetrag',
      key: 'totalPrice',
      col: 2,
      unit: 'EUR',
    },
  ],
})
